import React from "react";
import {Card, CardContent, Typography, Grid} from "@mui/material";
import Tooltip, {tooltipClasses} from "@mui/material/Tooltip";
import {styled} from "@mui/system";

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{popper: className}} />

    ))(({theme}) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#fff",
            color: "rgba(51, 51, 207, 0.808)",
            boxShadow: "0px 5px 5px -3px rgb(0 0 0 / 10%), 0px 8px 10px 1px rgb(0 0 0 / 4%), 0px 3px 14px 2px rgba(0,0,0,0.12)",
            fontSize: 13,
            padding: theme.spacing(2),
            borderRadius: theme.shape.borderRadius, 
        },
  
        "& .MuiTooltip-arrow": {
            color: "#fff", 

            "&:before": {
                //
            }
        }
    })
);

const VerificationMetricsComponent = (props) => {
    const {breakpoints, dashboardOverviewCount} = props;


    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
                <LightTooltip title="Total number of successful verifications" arrow placement="top">
                    <Card variant="outlined" sx={{backgroundColor: "#40BF7E1A", border: "0.1px solid #40BF7E", borderRadius: "8px"}}>
                        <CardContent sx={{pb: "16px !important"}}>
                            <Typography variant="body2" sx={{fontSize: "16px", color: "#58565f"}}>
                                Total Successful Verifications
                            </Typography>

                            <Typography variant="body2" sx={{fontSize: "16px", color: "#40BF7E", fontWeight: "bold", mt: "5px"}}>
                                {dashboardOverviewCount?.totalSuccessful.toLocaleString() || 0}                      
                            </Typography>
                        </CardContent>
                    </Card>
                </LightTooltip>
            </Grid>

            <Grid item xs={12} sm={3}>
                <LightTooltip title="Total verifications completed in the current month" arrow placement="top"> 
                    <Card variant="outlined" sx={{backgroundColor: "#FFA50014", border: "0.1px solid #FFA500", borderRadius: "8px"}}>
                        <CardContent sx={{pb: "16px !important"}}>
                            <Typography variant="body2" sx={{fontSize: "16px", color: "#58565f"}}>
                                Total Verifications in a Month
                            </Typography>

                            <Typography variant="body2" sx={{fontSize: "16px", color: "#40BF7E", fontWeight: "bold", mt: "5px"}}>
                                {dashboardOverviewCount?.countLastMonth.toLocaleString() || 0}                        
                            </Typography>
                        </CardContent>
                    </Card>
                </LightTooltip>
            </Grid>

            <Grid item xs={12} sm={3}>
                <LightTooltip title="Total verifications completed in the current week" arrow placement="top">
                    <Card variant="outlined" sx={{backgroundColor: "#E76C5920", border: "0.1px solid #E76C59", borderRadius: "8px"}}>
                        <CardContent sx={{pb: "16px !important"}}>
                            <Typography variant="body2" sx={{fontSize: "16px", color: "#58565f"}}>
                                Total Verifications in a Week
                            </Typography>

                            <Typography variant="body2" sx={{fontSize: "16px", color: "#40BF7E", fontWeight: "bold", mt: "5px"}}>
                                {dashboardOverviewCount?.countLastWeek.toLocaleString() || 0}                      
                            </Typography>
                        </CardContent>
                    </Card>
                </LightTooltip>
            </Grid>

            <Grid item xs={12} sm={3}>
                <LightTooltip title="Total verifications completed today" arrow placement="top">
                    <Card variant="outlined" sx={{backgroundColor: "#3333CF14", border: "0.1px solid #3333CF", borderRadius: "8px"}}>
                        <CardContent sx={{pb: "16px !important"}}>
                            <Typography variant="body2" sx={{fontSize: "16px", color: "#58565f"}}>
                                Total Verifications Today 
                            </Typography>

                            <Typography variant="body2" sx={{fontSize: "16px", color: "#40BF7E", fontWeight: "bold", mt: "5px"}}>
                                {dashboardOverviewCount?.countToday.toLocaleString() || 0}                      
                            </Typography>
                        </CardContent>
                    </Card>
                </LightTooltip>
            </Grid>
        </Grid>
    )
}

export default VerificationMetricsComponent